/* eslint-disable */

import type { BytemdSafeMdxViewerPlugin } from '@tarslib/bytemd-processor';

export default function openExternalLink({
  handleOnClick,
  slugIdPrefix,
  isSupportHash,
  enableHeadingSlugId,
}: {
  handleOnClick?: (url: string, e: MouseEvent) => void;
  slugIdPrefix?: string;
  isSupportHash?: boolean;
  enableHeadingSlugId?: boolean;
}): BytemdSafeMdxViewerPlugin {
  return {
    viewerEffect({ markdownBody }) {
      if (!handleOnClick) return;
      const hasBind = !!markdownBody.getAttribute('data-plugin-external-link');
      if (!hasBind) {
        markdownBody.setAttribute('data-plugin-external-link', 'true');
      }
      // 禁止 a 标签的原生跳转能力
      markdownBody.querySelectorAll('a').forEach((el) => {
        if (!el.getAttribute('data-plugin-external-link')) {
          el.setAttribute('data-plugin-external-link', 'true');
          const href = el.getAttribute('href');
          const activeHref = (() => {
            if (href?.startsWith('#')) {
              return decodeURI(`#${slugIdPrefix}${href.substring(1)}`);
            }
            return href ?? '#';
          })();
          el.setAttribute('href', activeHref);
        }
      });
    },
  };
}

/* eslint-enable */
